import script from "./SidebarItemMolecule.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarItemMolecule.vue?vue&type=script&setup=true&lang=ts"

import "./SidebarItemMolecule.css?vue&type=style&index=0&Scoped=true&lang=css&external"

const __exports__ = script;

export default __exports__